import type { C1_FurnitureDefinition, C1_FurnitureRendererProps } from "../../types/C1_FurnitureTypes";
import { RoomType } from "../../types/C1_ModelTypes";
import { C1_FurnitureIcon } from "../C1_FurnitureIcon";
import { C1_FurnitureSvg } from "../C1_FurnitureSvg";

const DEFAULT_WIDTH = 0.6;
const DEFAULT_HEIGHT = 0.6;

const Sink: C1_FurnitureDefinition = {
  id: "sink",
  icon: <C1_FurnitureIcon kind="sink" />,
  description: { en: "Sink", de: "Spüle" },
  category: RoomType.Kitchen,
  defaultWidth: DEFAULT_WIDTH,
  defaultHeight: DEFAULT_HEIGHT,
  autoRotate: true,
  autoReflect: true,
  grabsW: true,
  grabsH: false,
  properties: [],
  Renderer: ({
    width,
    height,
    rotation,
    PX,
    strokeWidth,
    strokeColor,
    fillColor,
    showDetails,
  }: C1_FurnitureRendererProps) => {
    const color = strokeColor ?? "#000000";
    const lineWidth = strokeWidth ?? 2;
    const inset = 0.02 * PX;
    const basinX = width * 0.17;
    const basinY = height * 0.22;
    const basinWidth = width * 0.66;
    const basinHeight = height * 0.63;
    const faucetTop = Math.max(inset, height * 0.05);
    const faucetY = height * 0.22;

    return (
      <C1_FurnitureSvg
        PX={PX}
        width={width}
        height={height}
        rotation={rotation ?? 0}
        viewBoxWidth={width}
        viewBoxHeight={height}
        originXPercentage={0}
        originYPercentage={0}
      >
        <rect
          x={inset}
          y={inset}
          width={Math.max(0, width - inset * 2)}
          height={Math.max(0, height - inset * 2)}
          rx={inset}
          fill={fillColor ?? "#ffffff"}
          stroke={color}
          strokeWidth={lineWidth * 2}
        />
        {showDetails && (
          <>
            <rect
              x={basinX}
              y={basinY}
              width={basinWidth}
              height={basinHeight}
              rx={Math.min(width, height) * 0.16}
              fill="none"
              stroke={color}
              strokeWidth={lineWidth}
            />
            <circle
              cx={width / 2}
              cy={height * 0.67}
              r={Math.min(width, height) * 0.04}
              fill="none"
              stroke={color}
              strokeWidth={lineWidth}
            />
            <path
              d={`M${width * 0.37} ${faucetY}V${height * 0.13}h${width * 0.26}v${faucetY - height * 0.13}M${width / 2} ${height * 0.13}V${faucetTop}`}
              fill="none"
              stroke={color}
              strokeWidth={lineWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        )}
      </C1_FurnitureSvg>
    );
  },
};

export default Sink;
